export const SHOW_ERRORS = 'show_errors';
export const SHOW_LOADER = 'show_loader';
export const STOP_LOADER = 'stop_loader';
export const SHOW_MSG = 'show_msg';
export const SET_NOTIFICATION = 'set_notification';
